
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.784 2H4M14.784 16H4","stroke":"#7D1E36","stroke-width":"1.3","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M5.56 2.65h7.36a9.09 9.09 0 01-1.202 3.723c-.774 1.297-1.693 1.977-2.47 1.977-.377 0-.8-.162-1.247-.515-.445-.352-.879-.868-1.257-1.499-.65-1.084-1.095-2.431-1.183-3.686zM5.56 15.35h7.36a9.09 9.09 0 00-1.202-3.723c-.774-1.297-1.693-1.977-2.47-1.977-.377 0-.8.162-1.247.515-.445.352-.879.868-1.257 1.499-.65 1.084-1.095 2.431-1.183 3.686z","stroke":"#7D1E36","stroke-width":"1.3"}}),_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"d":"M10.832 6H7.833c-.033.446.717 1 1.5 1 .782 0 1.499-.54 1.499-1z"}})]),_c('path',{attrs:{"d":"M7.833 6V4.7H6.625l-.088 1.205L7.833 6zm2.999 0h1.3V4.7h-1.3V6zM7.833 7.3h2.999V4.7H7.833v2.6zm1.5-1.6a.61.61 0 01-.316-.102c-.04-.028-.03-.03.002.016.027.039.13.209.11.48l-2.592-.189c-.037.495.149.901.331 1.17.188.276.43.495.67.662.477.329 1.114.563 1.795.563V5.7zm.199.3a.69.69 0 01.105-.388c.026-.037.033-.032-.003-.007a.552.552 0 01-.301.095v2.6c.677 0 1.308-.229 1.785-.56.409-.284 1.014-.875 1.014-1.74h-2.6z","fill":"#7D1E36","mask":"url(#a)"}}),_c('path',{attrs:{"d":"M11.118 15.03H7.626c.102-.245.257-.493.459-.715.386-.426.856-.665 1.279-.665.421 0 .905.246 1.3.68.204.223.357.466.454.7z","stroke":"#7D1E36","stroke-width":"1.3"}})])
          )
        }
      }
    